module.exports = __webpack_public_path__ + "img/venuetwo-dl.684aaebc.png";